module.exports = __webpack_public_path__ + "img/fuka.ce9c3c9c.png";